<template>
  <div id="input_delivery">
    <dd-header
      :isMenuView='false'
    />
    <dd-sitemap
      :pageKey="pageKey"
      :pageList="orderForm.pageList"
    />
    <div class="container">
      <div>
        <div class="title">
          <h1>発注者情報入力</h1>
        </div>
        <div class="input_list">
          <div>
            <ul>
              <li class="input_text2">
                <div>
                  <span>発注者名</span>
                  <span class="important small_text">必須</span>
                </div>
                <div class="input_field">
                  <input type="text" v-model="form.userLastName" maxlength="32" placeholder="家具"/>
                  <span class="space"></span>
                  <input type="text" v-model="form.userFirstName" maxlength="32" placeholder="太郎"/>
                </div>
                <div v-if="errors.userName" class="error_text">{{errors.userName}}</div>
              </li>
              <li class="input_text2">
                <div>
                  <span>発注者名（カナ）</span>
                  <span class="important small_text">必須</span>
                </div>
                <div class="input_field">
                  <input type="text" v-model="form.userLastNameKana" maxlength="32" placeholder="カグ"/>
                  <span class="space"></span>
                  <input type="text" v-model="form.userFirstNameKana" maxlength="32" placeholder="タロウ"/>
                </div>
                <div v-if="errors.userNameKana" class="error_text">{{errors.userNameKana}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>発注者電話番号</span>
                  <span class="small_p">（半角数値、ハイフン不要）</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model="form.tel" @keypress="validateNumber" @input="form.tel=inputRestNumber($event)" oninput="if(value.length>16)value=value.slice(0,16)" placeholder="0123456789"/>
                <div v-if="errors.tel" class="error_text">{{errors.tel}}</div>
              </li>
              <li class="input_text">
                <div>
                  <span>メールアドレス</span>
                  <span class="important small_text">必須</span>
                </div>
                <input type="text" v-model="form.email" placeholder="****@domans.co.jp" maxlength="128"/>
                <div v-if="errors.email" class="error_text">{{errors.email}}</div>
              </li>
            </ul>
          </div>
          <div v-if="errors.deliveryDate" class="error_text">{{errors.deliveryDate}}</div>
        </div>
        <div class="input_error_field">
          <div v-if="Object.keys(errors).length > 0" class="error_text">入力内容にエラーがあります。項目をご確認の上、もう一度入力してください。</div>
        </div>
      </div>
    </div>
    <div class="control_btn_area">
      <div class="detail_btn2" @click="onPrev()">〈〈&nbsp;&nbsp;&nbsp;戻る&nbsp;&nbsp;&nbsp;</div>
      <template v-if="orderForm.workFlag">
        <div class="detail_btn" @click="confirm()">組立設置先入力 〉〉</div>
      </template>
      <template v-else>
        <div class="detail_btn" @click="confirm()">ご注文内容確認 〉〉</div>
      </template>
    </div>
    <dd-footer />
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
  </div>
</template>
<script>
import axios from 'axios'

import * as Api from '../../utils/Api'
import * as App from '../../utils/App'
import * as Check from '../../utils/Check'
import * as FormUtil from '../../utils/FormUtil'
import {DC_URL, DC_STORAGE_KEY} from '../../constants/App'
import Calendar from '../../components/common/Calendar'
import LoadingModal from '../../components/common/LoadingModal'
// Module
import Header from '../components/common/DcHeader'
import Footer from '../components/common/DcFooter'
import SiteMap from '../components/common/DcSiteMap'
import ToolTip from '../../components/common/ToolTip'

export default {
  name: 'DcOrderGuest',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-sitemap': SiteMap,
    'dd-calendar': Calendar,
    'dd-loading-modal': LoadingModal,
    'tool-tip': ToolTip
  },
  props: {
    edit: Boolean
  },
  data () {
    return {
      pageKey: 'guest',
      form: {
        businessId: '',
        businessName: '',
        building: '',
        postcd: '',
        state: '',
        city: '',
        street: '',
        userLastName: '',
        userFirstName: '',
        userLastNameKana: '',
        userFirstNameKana: '',
        tel: '',
        deliveryDate: '',
        message: '',
        selectTime: 0,
        isRegistAddress: false
      },
      // 入力保持用のフォーム
      orderForm: {},
      errors: {},
      validateErrorMessages: {},
      schedule: {},
      inputFlag: false,
      imgQmark: this.getImage('common/qmark_gray.svg')
    }
  },
  methods: {
    confirm: function () {
      // 入力チェック
      this.errors = {}
      this.validateRequire()
      if (Object.keys(this.errors).length !== 0) {
        this.$refs.loadingModalRef.showModal(false)
        return
      }
      // 多重防止
      if (this.inputFlag) return
      this.inputFlag = true
      this.$refs.loadingModalRef.showModal(true)
      App.setLocalStorage(DC_STORAGE_KEY.GUEST_USER_INFO, this.form)
      axios.post(DC_URL.ORDER + '/input', this.form)
        .then(response => {
          if (response.data.errorMessage) {
            App.showModal({
              messages: [response.data.errorMessage]
            })
            this.$refs.loadingModalRef.showModal(false)
          } else {
            // 確認画面へ
            if (this.orderForm.workFlag) {
              this.$router.push({
                name: 'ConstructInput'
              })
            } else {
              this.$router.push({
                name: 'OrderConfirm'
              })
            }
          }
        }).catch(error => {
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.$router.push('/mmstyle/error')
          this.$refs.loadingModalRef.showModal(false)
        }).finally(() => {
          this.inputFlag = false
        })
    },
    validateNumber: function (event) {
      if (!Check.isNumber(event.key)) {
        event.preventDefault()
        return false
      }
      return true
    },
    fetchData: function () {
      let lform = App.getLocalStorage(DC_STORAGE_KEY.GUEST_USER_INFO)
      if (Object.keys(lform).length > 0) {
        this.form = Object.assign({}, lform)
      }
      let lorder = App.getLocalStorage(DC_STORAGE_KEY.ORDER_DATA)
      if (Object.keys(lorder).length > 0) {
        this.orderForm = Object.assign({}, lorder)
      }
    },
    validateRequire: function () {
      if (!this.form.userLastName || !this.form.userFirstName) this.errors['userName'] = '発注者名は必須項目です。'
      if (!this.form.userLastNameKana || !this.form.userFirstNameKana) this.errors['userNameKana'] = '発注者名（カナ）は必須項目です。'
      if (!this.form.tel) this.errors['tel'] = '受取人電話番号は必須項目です。'
      if (!this.form.email) this.errors['email'] = 'メールアドレスは必須項目です。'
    },
    getImage: function (image) {
      return App.getMmstyleResource(image)
    },
    onPrev: function () {
      this.$router.go(-1)
    },
    inputRestNumber: function (event) {
      // テキスト補正
      let str = FormUtil.restHalfNumber(event.target.value)
      if (str.length <= 0) {
        return ''
      }
      return str
    }
  }, // end method
  computed: {
  },
  watch: {
  },
  mounted () {
  },
  created () {
    this.fetchData()
  }
}
</script>
<style src="../css/dc-order.scss" lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/main/js/payment/pages/DcOrderGuest.vue